import { render, staticRenderFns } from "./gwp-groups.vue?vue&type=template&id=7fb2eb1a&scoped=true"
import script from "./gwp-groups.vue?vue&type=script&lang=js"
export * from "./gwp-groups.vue?vue&type=script&lang=js"
import style0 from "./gwp-groups.vue?vue&type=style&index=0&id=7fb2eb1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb2eb1a",
  null
  
)

export default component.exports